import React, { useState, useEffect } from "react";
import { readFile } from "../helpers";
import { ImgIcon } from ".";
import InfoIcon from "./InfoIcon";

export default function ShopPreview({ name, featureColor1 = "#C1204E", logo, bannerImage }) {

	const [logoData, setLogoData] = useState(null);
	const [bannerData, setBannerData] = useState(null);

	useEffect(() => {
		(async function () {
			if (logo instanceof Blob) {
				setLogoData(await readFile(logo));
			} else if (logo && typeof logo === "object" && logo.url) {
				setLogoData(logo.url);
			} else {
				setLogoData(null);
			}
		})();
	}, [logo]);

	useEffect(() => {
		(async function () {
			if (bannerImage instanceof Blob) {
				setBannerData(await readFile(bannerImage));
			} else if (bannerImage && typeof bannerImage === "object" && bannerImage.url) {
				setBannerData(bannerImage.url);
			} else {
				setBannerData(null);
			}
		})();
	}, [bannerImage]);

	return <div className="shopPreview">
		<div className="inner" style={{ backgroundColor: featureColor1 }}>
			{Boolean(bannerData) && <div className="overlay" style={{
				backgroundImage: `url("${bannerData}")`,
				backgroundPosition: "center",
				backgroundSize: "cover"
			}} />}
			<div className="info-box">
				{Boolean(logoData) && <ImgIcon
					src={logoData}
					bg={"#ffffff"}
					size={70}
				/>}
				<div className="info-box-content">
					<span className="heading featureFont">{name}</span>
				</div>
				<button className="info">
					<InfoIcon color={featureColor1} size={20} />
				</button>
			</div>
			<div className="navbar featureFont v-middle">
				<span className="active">Category A</span>
				<span>Category B</span>
				<span>Category C</span>
			</div>
			<div className="product-preview" style={{ color: featureColor1 }}>
				<span className="heading featureFont">Category A</span>
			</div>
		</div>
	</div>
}

/*
const a = <div className="shopPreview">
	<div className="inner">
		<div className="topbar" style={{ backgroundColor: featureColor1, color: featureColor2 }}>
			{Boolean(bannerData) && <div className="overlay" style={{
				backgroundImage: `url("${bannerData}")`,
				backgroundPosition: "center",
				backgroundSize: "cover"
			}} />}
			<div className="overlay" style={{ backgroundColor: featureColor1, opacity: 0.7 }} />
			<h3>{name}</h3>
		</div>
		{Boolean(logoData) && <ImgIcon
			src={logoData}
			bg={"#ffffff"}
			size={70}
		/>}
		<div className="shop-body">
			{Boolean(description) && <div className="description">
				{description.length > 30 ? description.slice(0, 30).trim() + "..." : description}
			</div>}
			<h5 className="productCategory" style={{ color: featureColor1 }}>
				Product Category
		</h5>
		</div>
	</div>
</div>
*/